z<template>
  <auth-layout pageClass="login-page">
    <b-row class="d-flex justify-content-center align-items-center">
      <b-col lg="4" md="6" sm="8">
        <form v-on:submit.prevent="onSubmit">
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">Login</h3>
              </div>
              <div>
                <fg-input label="Username"
                          placeholder="Enter username"
                          type="text"
                          autofocus
                          name="username"
                          v-model="model.username"
                          v-bind:class="errors.has('username') ? 'is-invalid':''" v-validate="'required'">

                </fg-input>
                <fg-input label="passsword"
                          type="password"
                          placeholder="Password"
                          name="password"
                          v-model="model.password"
                          v-bind:class="errors.has('password') ? 'is-invalid':''" v-validate="'required'">
                </fg-input>
              </div>
              <div class="text-center">
                <b-button variant="success" type="submit" class="btn-fill btn-round btn-wd "><font-awesome-icon v-if="isLoading" icon="spinner" spin /> Login</b-button>
                <!-- <br>
                <div class="forgot">
                  <router-link to="/forgot-password" class="card-category">
                    Forgot your password?
                  </router-link>
                </div> -->
              </div>
            </card>
          </fade-render-transition>
        </form>
      </b-col>
    </b-row>
  </auth-layout>
</template>
<script>
  import { FadeRenderTransition } from '@/components/index'
  import AuthLayout from './AuthLayout.vue'
  export default {
    components: {
      FadeRenderTransition,
      AuthLayout
    },
    data () {
      return {
        errorMsg: null,
        isLoading: false,
        model: {
          username: '',
          password: ''
        }
      }
    },
    methods: {
      onSubmit () {
        if (this.isLoading) {
          return false
        }
        this.$validator.validateAll().then(res => {
          this.$notifications.clear()
          if (res) {
            this.isLoading = true
            this.$store.dispatch('account/login', {
              username: this.model.username,
              password: this.model.password
            }).then((response) => {
              this.$store.dispatch('notification/welcome', this.$store.getters['account/accountData'].name)
              this.isLoading = false
              if (this.$route.query.redirect !== undefined && this.$route.query.redirect !== '/logout') {
                this.$router.push(this.$route.query.redirect)
              } else {
                this.$router.push('/dashboard')
              }
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      }
    }
  }
</script>

<style scoped>
  button svg {
    float: left;
    margin-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Auth/Login.vue